import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CourseItemComponent } from './course-item.component';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { RouterModule } from '@angular/router';
import { DaLinkModule } from '../da-link';
import { DaProgressiveImageModule } from '../da-progressive-image';
import { DaButtonModule } from '../da-button';
import { EventsModule } from '../events/events.module';

@NgModule({
    declarations: [CourseItemComponent],
    imports: [
        CommonModule,
        TranslateModule,
        RouterModule,
        LocalizeRouterModule,
        DaButtonModule,
        DaLinkModule,
        EventsModule,
        DaProgressiveImageModule
    ],
    providers: [],
    exports: [CourseItemComponent]
})
export class CourseItemModule {
    constructor() {}

    ngInit() {}
}
